(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-about"]) return;
  try {
    
  document.querySelectorAll('.collection-about').forEach((root) => {
    const body = root.querySelector('.collection-about__body');
    const toggle = root.querySelector('.collection-about__toggle');
    if (!body || !toggle) return;

    // Nothing is clipped, so a disclosure would be a lie — hide the toggle.
    const overflows = () => body.scrollHeight > body.clientHeight + 1;
    if (!overflows()) {
      toggle.hidden = true;
      body.dataset.collapsed = 'false';
      return;
    }

    toggle.addEventListener('click', () => {
      const collapsed = body.dataset.collapsed === 'true';
      body.dataset.collapsed = collapsed ? 'false' : 'true';
      toggle.setAttribute('aria-expanded', String(collapsed));
      toggle.textContent = '(' + (collapsed ? toggle.dataset.less : toggle.dataset.more) + ')';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-highlight"] && !Shopify.designMode) return;
  try {
    
  class CollectionHighlight {
    constructor(pin) {
      this.pin = pin;
      this.ch = pin.querySelector('[data-ch]');
      this.track = pin.querySelector('[data-ch-track]');
      this.dotsWrap = pin.querySelector('[data-ch-dots]');
      this.slides = this.track ? Array.from(this.track.children) : [];
      if (this.slides.length === 0) return;

      this.index = 0;
      this.ticking = false;

      // Below 768px the CSS unpins and the slides simply stack. Pinning several
      // screens on a phone fights the address-bar resize, which changes the
      // viewport height mid-scroll and makes the index jump.
      this.mq = window.matchMedia('(min-width: 768px)');

      this.#buildDots();
      this.#apply();

      // Horizon scrolls .page-wrapper at >=990px and the document below that
      // (see assets/scroll-container.js). Listen to both rather than guess.
      const onScroll = () => this.#onScroll();
      document.addEventListener('scroll', onScroll, { passive: true });
      document.querySelector('.page-wrapper')?.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);

      this.mq.addEventListener('change', () => {
        // leaving pinned mode: drop the inline transform so the stacked
        // fallback isn't left translated off-screen
        if (!this.mq.matches) this.track.style.transform = '';
        else this.#sync();
      });

      this.#sync();
    }

    #onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.ticking = false;
        this.#sync();
      });
    }

    #sync() {
      if (!this.mq.matches) return;

      // pinned travel = wrapper height - one sticky viewport. Measure the sticky
      // element rather than window.innerHeight: on desktop the scrollport is
      // .page-wrapper, not the window.
      const total = this.pin.offsetHeight - this.ch.offsetHeight;
      if (total <= 0) return;

      const scrolled = Math.min(Math.max(-this.pin.getBoundingClientRect().top, 0), total);
      const p = scrolled / total;

      // round -> each slide owns an equal band, switching at the midpoints
      const last = this.slides.length - 1;
      const i = Math.min(last, Math.max(0, Math.round(p * last)));
      if (i !== this.index) {
        this.index = i;
        this.#apply();
      }
    }

    #apply() {
      // % of the track's own height: the track is 100% of .ch and each slide is
      // one .ch tall, so one step == one slide whether that's vh or svh
      this.track.style.transform = `translate3d(0,${-this.index * 100}%,0)`;
      this.dots?.forEach((d, i) => {
        d.classList.toggle('is-active', i === this.index);
        d.setAttribute('aria-selected', String(i === this.index));
      });
      this.slides.forEach((s, i) => s.classList.toggle('is-active', i === this.index));
    }

    #buildDots() {
      if (!this.dotsWrap) return;
      this.dots = this.slides.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'ch__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => {
          if (!this.mq.matches) return;

          // Scroll by a measured delta rather than to an absolute offsetTop:
          // offsetTop is relative to the offset parent, and on desktop the
          // scrollport is .page-wrapper, not the document.
          const total = this.pin.offsetHeight - this.ch.offsetHeight;
          if (total <= 0) return;

          const last = this.slides.length - 1;
          const wanted = (total * i) / Math.max(1, last);
          const current = Math.min(Math.max(-this.pin.getBoundingClientRect().top, 0), total);
          const delta = wanted - current;
          if (!delta) return;

          const scroller = document.querySelector('.page-wrapper');
          const useScroller = scroller && scroller.scrollHeight > scroller.clientHeight;
          (useScroller ? scroller : window).scrollBy({ top: delta, behavior: 'smooth' });
        });
        this.dotsWrap.appendChild(dot);
        return dot;
      });
    }
  }

  document.querySelectorAll('[data-ch-pin]').forEach((el) => new CollectionHighlight(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(root) {
      this.root = root;
      this.slides = Array.from(root.querySelectorAll('[data-hero-slide]'));
      if (this.slides.length === 0) return;

      this.index = 0;
      this.timer = null;
      this.slides[0].classList.add('is-active');

      const prev = root.querySelector('[data-hero-prev]');
      const next = root.querySelector('[data-hero-next]');

      // A single slide has nowhere to go — drop the controls rather than
      // render dead buttons.
      if (this.slides.length < 2) {
        prev?.remove();
        next?.remove();
        return;
      }

      prev?.addEventListener('click', () => this.go(this.index - 1));
      next?.addEventListener('click', () => this.go(this.index + 1));

      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      document.addEventListener('visibilitychange', () =>
        document.hidden ? this.stop() : this.start()
      );

      this.start();
    }

    go(next) {
      const total = this.slides.length;
      const i = (next + total) % total;
      this.slides[this.index]?.classList.remove('is-active');
      this.slides[i]?.classList.add('is-active');
      this.index = i;
      this.start();
    }

    start() {
      this.stop();
      if (this.root.dataset.autoplay !== 'true') return;
      const speed = Number(this.root.dataset.autoplaySpeed || 5) * 1000;
      this.timer = setInterval(() => this.go(this.index + 1), speed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-hero-slider]').forEach((el) => new HeroSlider(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newin"] && !Shopify.designMode) return;
  try {
    
  class NewInCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-newin-track]');
      this.dotsWrap = root.querySelector('[data-newin-dots]');
      this.items = this.track ? Array.from(this.track.children) : [];
      if (this.items.length === 0) return;

      this.index = 0;
      this.maxIndex = 0;
      this.timer = null;

      this.#buildDots();
      this.#bindDrag();

      root.addEventListener('mouseenter', () => this.stop());
      root.addEventListener('mouseleave', () => this.start());
      document.addEventListener('visibilitychange', () =>
        document.hidden ? this.stop() : this.start()
      );

      let raf;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.layout());
      });
      window.addEventListener('load', () => this.layout());

      this.layout();
      this.start();
    }

    #itemWidth() {
      return this.items[0].getBoundingClientRect().width || 0;
    }

    #perView() {
      const w = this.#itemWidth();
      if (!w) return 1;
      return Math.max(1, Math.round(this.track.getBoundingClientRect().width / w));
    }

    // A hidden or not-yet-laid-out track measures 0, and #perView would wrongly
    // settle on 1. Bail and wait for resize/load.
    layout() {
      if (!this.#itemWidth()) return;
      this.maxIndex = Math.max(0, this.items.length - this.#perView());
      if (this.index > this.maxIndex) this.index = this.maxIndex;
      this.#buildDots();
      this.paint();
    }

    paint() {
      this.track.style.transform = `translate3d(${-this.index * this.#itemWidth()}px,0,0)`;
      this.dots?.forEach((d, i) => {
        d.classList.toggle('is-active', i === this.index);
        d.setAttribute('aria-selected', String(i === this.index));
      });
    }

    go(next) {
      const total = this.maxIndex + 1;
      this.index = ((next % total) + total) % total;
      this.paint();
      this.start();
    }

    #buildDots() {
      if (!this.dotsWrap) return;
      const count = this.maxIndex + 1;
      if (this.dots && this.dots.length === count) return;

      this.dotsWrap.innerHTML = '';
      this.dots = Array.from({ length: count }, (_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'newin__dot' + (i === this.index ? ' is-active' : '');
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Go to slide ${i + 1}`);
        dot.addEventListener('click', () => this.go(i));
        this.dotsWrap.appendChild(dot);
        return dot;
      });
    }

    #bindDrag() {
      const THRESHOLD = 40;
      const SLOP = 6;
      let startX = 0, startY = 0, delta = 0;
      let dragging = false, decided = false, suppressClick = false, pointerId = null;

      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        delta = 0;
        dragging = true;
        decided = false;
        this.stop();
      });

      this.track.addEventListener('pointermove', (e) => {
        if (!dragging || e.pointerId !== pointerId) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        if (!decided) {
          if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
          // a mostly-vertical gesture is a page scroll, not a swipe
          if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
          decided = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(pointerId);
        }

        delta = dx;
        this.track.style.transform =
          `translate3d(${-this.index * this.#itemWidth() + delta}px,0,0)`;
      });

      const end = () => {
        if (!dragging) return;
        dragging = false;
        this.track.classList.remove('is-dragging');
        if (pointerId !== null && this.track.hasPointerCapture(pointerId)) {
          this.track.releasePointerCapture(pointerId);
        }

        const moved = delta;
        delta = 0;
        pointerId = null;

        if (decided && Math.abs(moved) > THRESHOLD) {
          // the pointerup is about to become a click on the tile beneath
          suppressClick = true;
          setTimeout(() => { suppressClick = false; }, 50);
          this.go(moved < 0 ? this.index + 1 : this.index - 1);
        } else {
          this.paint();
          this.start();
        }
        decided = false;
      };

      this.track.addEventListener('pointerup', end);
      this.track.addEventListener('pointercancel', end);
      this.track.addEventListener('click', (e) => {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      this.track.addEventListener('dragstart', (e) => e.preventDefault());
    }

    start() {
      this.stop();
      if (this.root.dataset.autoplay !== 'true' || this.maxIndex < 1) return;
      const speed = Number(this.root.dataset.autoplaySpeed || 4) * 1000;
      this.timer = setInterval(() => this.go(this.index + 1), speed);
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    }
  }

  document.querySelectorAll('[data-newin]').forEach((el) => new NewInCarousel(el));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class RecsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.recs-carousel__track');
      if (!this.track) {
        console.warn('[recs-carousel] no track found — carousel not initialized');
        return;
      }
      this.items = Array.from(this.track.children).filter(
        (el) => el.classList && el.classList.contains('resource-list__item')
      );

      // Safety net: drop any card that links to the current product (the AJAX
      // recommendations context can't always exclude it server-side).
      const here = window.location.pathname.replace(/\/+$/, '');
      this.items = this.items.filter((item) => {
        const link = item.querySelector('a[href]');
        if (!link) return true;
        const path = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/+$/, '');
        if (path === here) {
          item.remove();
          return false;
        }
        return true;
      });

      this.prevBtn = this.querySelector('.recs-carousel__arrow--prev');
      this.nextBtn = this.querySelector('.recs-carousel__arrow--next');
      this.index = 0;

      this.onPrev = () => this.nudge(-1);
      this.onNext = () => this.nudge(1);
      this.onEnter = () => this.stop();
      this.onLeave = () => this.start();
      this.onResize = () => this.apply();

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      window.addEventListener('resize', this.onResize);

      this.apply();
      this.start();
    }

    disconnectedCallback() {
      this.stop();
      window.removeEventListener('resize', this.onResize);
    }

    get visible() {
      const w = window.innerWidth;
      if (w < 750) return 2;
      if (w < 990) return 3;
      return 4;
    }

    get interval() {
      return Number(this.getAttribute('data-interval')) || 4500;
    }

    get maxIndex() {
      return Math.max(0, this.items.length - this.visible);
    }

    /* Manual arrow: pause, move, then resume the auto-slide. */
    nudge(dir) {
      this.stop();
      this.step(dir);
      this.start();
    }

    /* Page by one full set of visible cards, wrapping infinitely at both ends. */
    step(dir) {
      const max = this.maxIndex;
      if (max === 0) return;
      if (dir > 0) {
        this.index = this.index >= max ? 0 : Math.min(this.index + this.visible, max);
      } else {
        this.index = this.index <= 0 ? max : Math.max(this.index - this.visible, 0);
      }
      this.apply();
    }

    apply() {
      if (this.index > this.maxIndex) this.index = this.maxIndex;
      const perCard = 100 / this.visible;
      this.track.style.transform = 'translateX(-' + this.index * perCard + '%)';
      const enabled = this.maxIndex > 0;
      if (this.prevBtn) this.prevBtn.style.display = enabled ? '' : 'none';
      if (this.nextBtn) this.nextBtn.style.display = enabled ? '' : 'none';
    }

    start() {
      this.stop();
      if (this.maxIndex > 0) {
        this.timer = window.setInterval(() => this.step(1), this.interval);
      }
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }
  }

  if (!customElements.get('recs-carousel')) {
    customElements.define('recs-carousel', RecsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-related"] && !Shopify.designMode) return;
  try {
    
  class RecsCarousel extends HTMLElement {
    connectedCallback() {
      // The element can upgrade mid-parse (children not in the DOM yet), so wait
      // for the document to be ready before querying/measuring.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }

    init() {
      if (this.ready) return;
      this.viewport = this.querySelector('.recs-carousel__viewport');
      this.track = this.querySelector('.recs-carousel__track');
      if (!this.viewport || !this.track) return;
      this.ready = true;
      this.prevBtn = this.querySelector('.recs-carousel__arrow--prev');
      this.nextBtn = this.querySelector('.recs-carousel__arrow--next');

      // Safety net: drop any card linking to the current product.
      const here = window.location.pathname.replace(/\/+$/, '');
      Array.from(this.track.children).forEach((item) => {
        const link = item.querySelector('a[href]');
        if (!link) return;
        const path = new URL(link.getAttribute('href'), window.location.origin).pathname.replace(/\/+$/, '');
        if (path === here) item.remove();
      });

      this.dragging = false;
      this.moved = false;

      this._down = (e) => this.onDown(e);
      this._move = (e) => this.onMove(e);
      this._up = () => this.onUp();
      this._clickCapture = (e) => this.onClickCapture(e);

      this.viewport.addEventListener('pointerdown', this._down);
      this.addEventListener('click', this._clickCapture, true);
      this.addEventListener('dragstart', (e) => e.preventDefault());
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.nudge(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.nudge(1));
      this.addEventListener('mouseenter', () => this.stopAuto());
      this.addEventListener('mouseleave', () => this.startAuto());

      // ResizeObserver fires after layout (real widths) and on every resize, so
      // measurement never runs at width 0.
      this.ro = new ResizeObserver(() => this.refresh());
      this.ro.observe(this.viewport);
      requestAnimationFrame(() => this.refresh());

      this.startAuto();
    }

    disconnectedCallback() {
      this.stopAuto();
      if (this.ro) this.ro.disconnect();
      window.removeEventListener('pointermove', this._move);
      window.removeEventListener('pointerup', this._up);
    }

    get interval() {
      return Number(this.getAttribute('data-interval')) || 4500;
    }

    hasOverflow() {
      return this.viewport.scrollWidth > this.viewport.clientWidth + 1;
    }

    refresh() {
      if (!this.viewport || !this.track) return;
      const over = this.hasOverflow();
      this.classList.toggle('is-draggable', over);
      if (this.prevBtn) this.prevBtn.style.display = over ? '' : 'none';
      if (this.nextBtn) this.nextBtn.style.display = over ? '' : 'none';
      if (!over) this.stopAuto();
    }

    // Page by one full viewport (a set of cards), wrapping infinitely.
    nudge(dir) {
      this.stopAuto();
      this.page(dir);
      this.startAuto();
    }

    page(dir) {
      const vp = this.viewport;
      const w = vp.clientWidth;
      const max = vp.scrollWidth - w;
      let target;
      if (dir > 0) {
        target = vp.scrollLeft >= max - 2 ? 0 : Math.min(vp.scrollLeft + w, max);
      } else {
        target = vp.scrollLeft <= 2 ? max : Math.max(vp.scrollLeft - w, 0);
      }
      vp.scrollTo({ left: target, behavior: 'smooth' });
    }

    startAuto() {
      this.stopAuto();
      if (this.hasOverflow()) {
        this.timer = window.setInterval(() => this.page(1), this.interval);
      }
    }

    stopAuto() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    // ── Desktop pointer drag-to-scroll (touch uses native scroll) ──
    onDown(e) {
      if (e.pointerType === 'touch') return;
      if (!this.hasOverflow()) return;
      this.dragging = true;
      this.moved = false;
      this.startX = e.clientX;
      this.startScroll = this.viewport.scrollLeft;
      this.classList.add('is-dragging');
      this.stopAuto();
      window.addEventListener('pointermove', this._move);
      window.addEventListener('pointerup', this._up);
    }

    onMove(e) {
      if (!this.dragging) return;
      const dx = e.clientX - this.startX;
      if (Math.abs(dx) > 5) this.moved = true;
      this.viewport.scrollLeft = this.startScroll - dx;
    }

    onUp() {
      if (!this.dragging) return;
      this.dragging = false;
      this.classList.remove('is-dragging');
      window.removeEventListener('pointermove', this._move);
      window.removeEventListener('pointerup', this._up);
      this.startAuto();
    }

    // Cancel the click that follows a real drag so product links don't fire.
    onClickCapture(e) {
      if (this.moved) {
        e.preventDefault();
        e.stopPropagation();
        this.moved = false;
      }
    }
  }

  if (!customElements.get('recs-carousel')) {
    customElements.define('recs-carousel', RecsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trending"] && !Shopify.designMode) return;
  try {
    
  /* Seamless infinite loop.

     The track holds [ lead clones | originals | trail clones ]. `pos` is the
     index of the leftmost visible tile, kept inside the originals band
     [lead, lead + N). Stepping past either edge animates into a clone — which
     looks identical to the tile it copies — and on transitionend we shift `pos`
     back by N and re-apply the transform with transition:none. The pixels don't
     move, so the reset is invisible.

     lead = N * REPEAT so a full viewport of tiles always exists beyond the band
     in both directions; REPEAT covers the widest perView (4-up). */
  class ProductRow {
    constructor(row) {
      this.row = row;
      this.track = row.querySelector('[data-prod-track]');
      this.prev = row.querySelector('[data-prod-prev]');
      this.next = row.querySelector('[data-prod-next]');
      if (!this.track || !this.prev || !this.next) return;

      this.originals = Array.from(this.track.children);
      this.N = this.originals.length;
      if (!this.N) return;

      const MAX_PER_VIEW = 4;
      this.looping = this.N >= 2;
      this.REPEAT = this.looping ? Math.max(1, Math.ceil(MAX_PER_VIEW / this.N)) : 0;
      this.lead = this.N * this.REPEAT;

      this.pos = this.lead;
      this.itemW = 0;
      this.perView = 1;
      this.animating = false;

      if (this.looping) this.#cloneBands();

      this.track.addEventListener('transitionend', (e) => {
        if (e.target !== this.track || e.propertyName !== 'transform') return;
        this.animating = false;
        this.#normalize();
      });

      this.prev.addEventListener('click', () => this.#step(-1));
      this.next.addEventListener('click', () => this.#step(1));

      this.#bindDrag();

      let raf;
      window.addEventListener('resize', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => this.layout());
      });
      window.addEventListener('load', () => this.layout());

      row._refresh = () => this.layout();
      this.layout();
    }

    #cloneBands() {
      const cloneSet = () =>
        this.originals.map((node) => {
          const c = node.cloneNode(true);
          c.classList.add('is-clone');
          c.setAttribute('aria-hidden', 'true');
          // clones must never take focus or be announced twice
          c.querySelectorAll('a,button,input,select').forEach((el) => (el.tabIndex = -1));
          return c;
        });

      for (let r = 0; r < this.REPEAT; r++) {
        cloneSet().forEach((c) => this.track.appendChild(c));
        // reverse so inserting each at the front rebuilds the original order
        cloneSet()
          .reverse()
          .forEach((c) => this.track.insertBefore(c, this.track.firstChild));
      }
    }

    #measure() {
      this.itemW = this.originals[0].getBoundingClientRect().width || 0;
      if (!this.itemW) return false;
      this.perView = Math.max(1, Math.round(this.track.getBoundingClientRect().width / this.itemW));
      return true;
    }

    // animate=false performs the silent reset: kill the transition, move, force
    // a reflow so the browser commits it, then restore the transition
    #setPos(animate) {
      if (!animate) this.track.style.transition = 'none';
      this.track.style.transform = `translate3d(${-this.pos * this.itemW}px,0,0)`;
      if (!animate) {
        void this.track.offsetWidth; /* reflow — do not remove */
        this.track.style.transition = '';
      }
    }

    #normalize() {
      if (!this.looping) return;
      if (this.pos >= this.lead + this.N) {
        this.pos -= this.N;
        this.#setPos(false);
      } else if (this.pos < this.lead) {
        this.pos += this.N;
        this.#setPos(false);
      }
    }

    // Mobile advances a full page (perView = 2-up); desktop keeps single-card
    // stepping so the desktop behaviour is untouched.
    #pageBy() {
      return window.matchMedia('(max-width: 749px)').matches ? this.perView : 1;
    }

    #step(dir) {
      if (!this.itemW && !this.#measure()) return; /* still hidden */
      if (this.animating) return; /* one gesture at a time */
      this.animating = true;
      this.pos += dir * this.#pageBy();
      this.#setPos(true);
    }

    #bindDrag() {
      const THRESHOLD = 40;
      const SLOP = 6;
      let startX = 0, startY = 0, delta = 0;
      let dragging = false, decided = false, suppressClick = false, pointerId = null;

      this.track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        if (this.animating || (!this.itemW && !this.#measure())) return;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        delta = 0;
        dragging = true;
        decided = false;
      });

      this.track.addEventListener('pointermove', (e) => {
        if (!dragging || e.pointerId !== pointerId) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;

        if (!decided) {
          if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
          if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; } /* page scroll */
          decided = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(pointerId);
        }

        delta = dx;
        this.track.style.transform = `translate3d(${-this.pos * this.itemW + delta}px,0,0)`;
      });

      const end = () => {
        if (!dragging) return;
        dragging = false;
        this.track.classList.remove('is-dragging');
        if (pointerId !== null && this.track.hasPointerCapture(pointerId)) {
          this.track.releasePointerCapture(pointerId);
        }

        const moved = delta;
        delta = 0;
        pointerId = null;

        if (decided && Math.abs(moved) > THRESHOLD) {
          suppressClick = true;
          setTimeout(() => { suppressClick = false; }, 50);
          this.animating = true;
          this.pos += (moved < 0 ? 1 : -1) * this.#pageBy();
          this.#setPos(true);
        } else {
          this.#setPos(true); /* snap back */
          if (!decided) this.animating = false;
        }
        decided = false;
      };

      this.track.addEventListener('pointerup', end);
      this.track.addEventListener('pointercancel', end);
      this.track.addEventListener('click', (e) => {
        if (suppressClick) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      this.track.addEventListener('dragstart', (e) => e.preventDefault());
    }

    // A hidden panel measures 0 in every direction, so perView would wrongly
    // settle on 1. Bail and wait to be refreshed when the tab is shown.
    layout() {
      if (!this.#measure()) return;
      this.#setPos(false);
    }
  }

  document.querySelectorAll('[data-prod]').forEach((el) => new ProductRow(el));

  /* ---- tabs ---- */
  document.querySelectorAll('[data-trending]').forEach((trending) => {
    const tabs = Array.from(trending.querySelectorAll('.tablayout__link'));
    const panels = Array.from(trending.querySelectorAll('.trending__panel'));
    if (!tabs.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const id = tab.dataset.tab;

        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
        });

        panels.forEach((panel) => {
          const on = panel.id === id;
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;

          // the panel was display:none until now, so its row measured 0 and
          // never laid out — re-measure it on the way in
          if (on) {
            const row = panel.querySelector('[data-prod]');
            if (row && typeof row._refresh === 'function') row._refresh();
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["world-of-inspiration"] && !Shopify.designMode) return;
  try {
    
  class WorldOfInspiration {
    constructor(root) {
      this.root = root;
      this.tiles = Array.from(root.querySelectorAll('[data-woi-tile]'));
      if (this.tiles.length === 0) return;

      this.caption = root.querySelector('[data-woi-caption]');
      this.handle = root.querySelector('[data-woi-handle]');
      this.handleLink = root.querySelector('[data-woi-handle-link]');
      this.row = root.querySelector('[data-woi-row]');
      this.index = 0;

      root.querySelector('[data-woi-prev]')?.addEventListener('click', () => this.go(-1));
      root.querySelector('[data-woi-next]')?.addEventListener('click', () => this.go(1));

      // hovering / focusing a tile makes it the active one in the panel
      this.tiles.forEach((tile, i) => {
        tile.addEventListener('mouseenter', () => this.setActive(i, false));
        tile.addEventListener('focus', () => this.setActive(i, false));
      });

      this.setActive(0, false);
    }

    go(dir) {
      const n = this.tiles.length;
      this.setActive((this.index + dir + n) % n, true);
    }

    setActive(i, scroll) {
      this.index = i;
      const tile = this.tiles[i];
      if (!tile) return;

      this.tiles.forEach((t, j) => t.classList.toggle('is-active', j === i));

      if (this.caption) this.caption.textContent = tile.dataset.caption || '';
      if (this.handle) this.handle.textContent = tile.dataset.handle || '';
      if (this.handleLink) this.handleLink.setAttribute('href', tile.getAttribute('href') || '#');

      if (scroll) {
        tile.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  }

  document.querySelectorAll('[data-woi]').forEach((el) => new WorldOfInspiration(el));

  } catch(e) { console.error(e); }
})();
})();
